import classNames from 'classnames';
import { cloneElement, isValidElement, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  readonly children: ReactElement<HTMLElement>;
};

/** Mirrors a directional glyph (chevron, arrow) when the UI language is RTL. */
function FlipOnRtl({ children }: Props) {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';

  if (!isValidElement(children)) {
    return children;
  }

  return cloneElement(children, {
    className: classNames(children.props.className, isRtl && '-scale-x-100'),
  });
}

export default FlipOnRtl;
